import {
  AVALIACOES_MODELOS_QUESTOES_LIST,
  AVALIACOES_MODELOS_QUESTOES_ADD,
  AVALIACOES_MODELOS_QUESTOES_REMOVE
} from '../const/servicesURI';
import requestService from './requestService';
import utils from '../utils';
import { httpRequests } from 'investira.sdk';

const cancel = {
  list: null
};

export const list = (pParams, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    ...pRequestOptions,
    params: pParams,
    cancelToken: cancel.list.token
  };

  return requestService(xProps, AVALIACOES_MODELOS_QUESTOES_LIST, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service ModelosQuestoes List');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const add = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_MODELOS_QUESTOES_ADD, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service ModelosQuestoes Add');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'DELETE'
  };

  return requestService(xProps, AVALIACOES_MODELOS_QUESTOES_REMOVE, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service ModelosQuestoes Remove');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const modelosQuestoes = { list, add, remove, cancel };

export default modelosQuestoes;
